export enum RR_WEBVIEWER_FILE_STATES {
  JSON_LIST,
  JSON_OBJECT_LIST,
  JSON_SINGLE,
  CONVERT_JSON,
}
